export function getItem(key: string = '', di: StorageServiceDependencies = {}): any {
  const {wndw = window, json = JSON} = di;
  const storage: Storage = wndw.localStorage;
  const value: string = storage.getItem(key);
  if (!value) return null;
  return json.parse(value);
}
